import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=cf1334fe&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/sidebar.scss?vue&type=style&index=0&id=cf1334fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1334fe",
  null
  
)

export default component.exports